import React from 'react';

const FilterBadge = ({ icon, label, onClear, accentColor = '#00FFFF' }) => {
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 12px',
      background: `${accentColor}15`,
      border: `1px solid ${accentColor}40`,
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      color: accentColor,
      boxShadow: `0 0 10px ${accentColor}30`,
      animation: 'badgeSlideIn 0.3s ease-out'
    }}>
      <span>{icon}</span>
      <span>{label}</span>
      <button
        onClick={onClear}
        style={{
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          border: `1px solid ${accentColor}60`,
          background: 'rgba(0, 0, 0, 0.3)',
          color: accentColor,
          fontSize: '10px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = `${accentColor}30`;
          e.target.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(0, 0, 0, 0.3)';
          e.target.style.transform = 'scale(1)';
        }}
      >
        ✕
      </button>

      <style>{`
        @keyframes badgeSlideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default FilterBadge;
